import { withLocalState } from 'pyradux';

import OfferDetailsContainer from './OfferDetails.container';
import reducer from './OfferDetails.reducer';
import OfferDetailsSagas from './OfferDetails.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'offerDetails',
  sagas: [OfferDetailsSagas],
};

export default withLocalState(withLocalStateOptions, OfferDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/OfferDetails/index.js